import controller from './kform-builder-option-options-label-position.controller';
import template from './kform-builder-option-options-label-position.html';

const kformBuilderOptionOptionsLabelPositionDirective = /* @ngInject */ () => ({
	restrict: 'E',
	replace: true,
	template,
	controller,
});

export default kformBuilderOptionOptionsLabelPositionDirective;
